"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformRequestAuthorizationCodeCodeChallengeMethod = exports.SdPlatformRequestAuthorizationCodeResponseType = exports.SdPlatformAuthGrantType = void 0;
/**
 * OAuth 2.0 grant type
 */
var SdPlatformAuthGrantType;
(function (SdPlatformAuthGrantType) {
    SdPlatformAuthGrantType["Password"] = "password";
    SdPlatformAuthGrantType["RefreshToken"] = "refresh_token";
    SdPlatformAuthGrantType["Code"] = "authorization_code";
})(SdPlatformAuthGrantType = exports.SdPlatformAuthGrantType || (exports.SdPlatformAuthGrantType = {}));
var SdPlatformRequestAuthorizationCodeResponseType;
(function (SdPlatformRequestAuthorizationCodeResponseType) {
    SdPlatformRequestAuthorizationCodeResponseType["Code"] = "code";
})(SdPlatformRequestAuthorizationCodeResponseType = exports.SdPlatformRequestAuthorizationCodeResponseType || (exports.SdPlatformRequestAuthorizationCodeResponseType = {}));
var SdPlatformRequestAuthorizationCodeCodeChallengeMethod;
(function (SdPlatformRequestAuthorizationCodeCodeChallengeMethod) {
    SdPlatformRequestAuthorizationCodeCodeChallengeMethod["S256"] = "S256";
})(SdPlatformRequestAuthorizationCodeCodeChallengeMethod = exports.SdPlatformRequestAuthorizationCodeCodeChallengeMethod || (exports.SdPlatformRequestAuthorizationCodeCodeChallengeMethod = {}));
//# sourceMappingURL=SdPlatformAuthRequest.js.map